import { createFileRoute, Outlet } from '@tanstack/react-router'
import { Page } from '@/components/ui/page'

export const Route = createFileRoute('/_app/settings')({
  staticData: { crumb: 'Configuración' },
  component: SettingsLayout,
})

function SettingsLayout() {
  return (
    <Page>
      <Outlet />
    </Page>
  )
}
